import React from "react";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "sso-google-callback",
    path: `${AUTH_PREFIX_PATH}/google/callback`,
    component: React.lazy(
      () => import("views/auth-views/authentication/sso-callback"),
    ),
  },
  {
    key: "sso-microsoft-callback",
    path: `${AUTH_PREFIX_PATH}/microsoft/callback`,
    component: React.lazy(
      () => import("views/auth-views/authentication/sso-callback"),
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(
      () => import("views/auth-views/authentication/register"),
    ),
  },
  {
    key: "open-register",
    path: `${AUTH_PREFIX_PATH}/open-register`,
    component: React.lazy(
      () => import("views/auth-views/authentication/open-register"),
    ),
  },
  //   https://qa-2.teamsunday.com/follow-up?value=Yes&question_id=9&email_id=1&appointment_id=1
  {
    key: "follow-up-questionnaire",
    path: `${APP_PREFIX_PATH}/follow-up`,
    component: React.lazy(
      () => import("views/app-views/follow-up-questionnaire"),
    ),
  },
  {
    key: "register-token",
    path: `${AUTH_PREFIX_PATH}/invitation`,
    component: React.lazy(
      () => import("views/auth-views/authentication/register-token"),
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
  {
    key: "confirm-password",
    path: `${AUTH_PREFIX_PATH}/password-confirmation`,
    component: React.lazy(
      () => import("views/auth-views/authentication/confirm-password"),
    ),
  },
  {
    key: "redeem-campaign",
    path: `${APP_PREFIX_PATH}/redeem-campaign`,
    component: React.lazy(() => import("views/app-views/redeem-campaign")),
    meta: { blankLayout: true },
  },
  {
    key: "live-quiz-screen",
    path: `${APP_PREFIX_PATH}/live-quiz`,
    component: React.lazy(() => import("views/app-views/live-quiz/screen")),
    meta: { blankLayout: true },
  },
  {
    key: "live-quiz-join",
    path: `${APP_PREFIX_PATH}/live-quiz/join`,
    component: React.lazy(() => import("views/app-views/live-quiz/join")),
    meta: { blankLayout: true },
  },
  {
    // BE spec v3: the quiz code lives in the URL (/live-quiz/{code}); the
    // code-less routes above stay as a fallback to the default quiz
    key: "live-quiz-screen-coded",
    path: `${APP_PREFIX_PATH}/live-quiz/:code`,
    component: React.lazy(() => import("views/app-views/live-quiz/screen")),
    meta: { blankLayout: true },
  },
  {
    key: "live-quiz-join-coded",
    path: `${APP_PREFIX_PATH}/live-quiz/:code/join`,
    component: React.lazy(() => import("views/app-views/live-quiz/join")),
    meta: { blankLayout: true },
  },
  {
    key: "internal-request-campaign",
    path: `${APP_PREFIX_PATH}/internal-request`,
    component: React.lazy(() => import("views/app-views/internal-request-campaign")),
    meta: { blankLayout: true },
  },
  {
    // New sharable_open_link format: /request-forms?token=... (the old
    // /internal-request links above keep working for already-shared URLs)
    key: "request-forms-public",
    path: `${APP_PREFIX_PATH}/request-forms`,
    component: React.lazy(() => import("views/app-views/internal-request-campaign")),
    meta: { blankLayout: true },
  },
  {
    key: "fair-and-events-onboarding",
    path: `${APP_PREFIX_PATH}/redeem-campaign/spin-the-wheel-onboarding/:companySlug`,
    component: React.lazy(() => import("views/app-views/fair-and-events/onboarding")),
    meta: { blankLayout: true },
  },
  {
    key: "fair-and-events-wheel-amalfi",
    path: `${APP_PREFIX_PATH}/spin-the-wheel/amalfi/:activationId`,
    component: React.lazy(() => import("views/app-views/fair-and-events/amalfi")),
    meta: { blankLayout: true },
  },
  {
    key: "fair-and-events-wheel",
    path: `${APP_PREFIX_PATH}/spin-the-wheel/:activationId`,
    component: React.lazy(() => import("views/app-views/fair-and-events")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas-spin-the-wheel",
    path: `${APP_PREFIX_PATH}/christmas-spin-the-wheel/:activationId`,
    component: React.lazy(() => import("views/app-views/fair-and-events/christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas-spin-the-wheel-base",
    path: `${APP_PREFIX_PATH}/christmas-spin-the-wheel`,
    component: React.lazy(() => import("views/app-views/fair-and-events/christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas-advent-calendar",
    path: `${APP_PREFIX_PATH}/christmas-advent-calendar/:activationId`,
    component: React.lazy(() => import("views/app-views/christmas-advent-calendar")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas-advent-calendar-base",
    path: `${APP_PREFIX_PATH}/christmas-advent-calendar`,
    component: React.lazy(() => import("views/app-views/christmas-advent-calendar")),
    meta: { blankLayout: true },
  },
  {
    key: "event-campaign",
    path: `${APP_PREFIX_PATH}/event-campaign`,
    component: React.lazy(() => import("views/app-views/event-campaign")),
    meta: { blankLayout: true },
  },
  {
    key: "websummit",
    path: `${APP_PREFIX_PATH}/redeem-campaign/websummit`,
    component: React.lazy(() => import("views/app-views/websummit")),
  },
  {
    key: "websummit-mystery",
    path: `${APP_PREFIX_PATH}/redeem-campaign/websummit/mystery`,
    component: React.lazy(() => import("views/app-views/websummit")),
  },
  {
    key: "amalfi",
    path: `${APP_PREFIX_PATH}/redeem-campaign/amalfi`,
    component: React.lazy(() => import("views/app-views/amalfi")),
    meta: { blankLayout: true },
  },
  {
    key: "donna",
    path: `${APP_PREFIX_PATH}/redeem-campaign/donna`,
    component: React.lazy(() => import("views/app-views/donna")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas",
    path: `${APP_PREFIX_PATH}/redeem-campaign/christmas`,
    component: React.lazy(() => import("views/app-views/christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "synergie",
    path: `${APP_PREFIX_PATH}/redeem-campaign/synergie`,
    component: React.lazy(() => import("views/app-views/synergie")),
    meta: { blankLayout: true },
  },
  {
    key: "synergie-christmas",
    path: `${APP_PREFIX_PATH}/redeem-campaign/synergie-christmas`,
    component: React.lazy(() => import("views/app-views/synergie-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "expertum-christmas",
    path: `${APP_PREFIX_PATH}/redeem-campaign/expertum-christmas`,
    component: React.lazy(() => import("views/app-views/expertum-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "imens",
    path: `${APP_PREFIX_PATH}/redeem-campaign/imens`,
    component: React.lazy(() => import("views/app-views/imens")),
    meta: { blankLayout: true },
  },
  {
    key: "appodeal",
    path: `${APP_PREFIX_PATH}/redeem-campaign/appodeal`,
    component: React.lazy(() => import("views/app-views/appodeal")),
    meta: { blankLayout: true },
  },
  {
    key: "vanloot",
    path: `${APP_PREFIX_PATH}/redeem-campaign/vanloot`,
    component: React.lazy(() => import("views/app-views/vanloot")),
    meta: { blankLayout: true },
  },
  {
    key: "bankb",
    path: `${APP_PREFIX_PATH}/redeem-campaign/bankb`,
    component: React.lazy(() => import("views/app-views/bankb")),
    meta: { blankLayout: true },
  },
  {
    key: "bankb-christmas",
    path: `${APP_PREFIX_PATH}/redeem-campaign/bankb-christmas`,
    component: React.lazy(() => import("views/app-views/bankb-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "bankb-christmas-s",
    path: `${APP_PREFIX_PATH}/redeem-campaign/bankb-christmas-s`,
    component: React.lazy(() => import("views/app-views/bankb-christmas-s")),
    meta: { blankLayout: true },
  },
  {
    key: "imens-christmas",
    path: `${APP_PREFIX_PATH}/redeem-campaign/imens-christmas`,
    component: React.lazy(() => import("views/app-views/imens-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "i-mens-christmas",
    path: `${APP_PREFIX_PATH}/redeem-campaign/i-mens-christmas`,
    component: React.lazy(() => import("views/app-views/i-mens-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "testronic",
    path: `${APP_PREFIX_PATH}/redeem-campaign/testronic`,
    component: React.lazy(() => import("views/app-views/testronic")),
    meta: { blankLayout: true },
  },
  {
    key: "testronic-christmas",
    path: `${APP_PREFIX_PATH}/redeem-campaign/testronic-christmas`,
    component: React.lazy(() => import("views/app-views/testronic-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas-gift",
    path: `${APP_PREFIX_PATH}/redeem-campaign/christmas-gift`,
    component: React.lazy(() => import("views/app-views/christmas-gift")),
    meta: { blankLayout: true },
  },
  {
    key: "nexo",
    path: `${APP_PREFIX_PATH}/redeem-campaign/nexo`,
    component: React.lazy(() => import("views/app-views/nexo")),
    meta: { blankLayout: true },
  },
  {
    key: "nexo-crypto",
    path: `${APP_PREFIX_PATH}/redeem-campaign/nexo-crypto`,
    component: React.lazy(() => import("views/app-views/nexo-crypto")),
    meta: { blankLayout: true },
  },
  {
    key: "amalfi-demo",
    path: `${APP_PREFIX_PATH}/demo/amalfi`,
    component: React.lazy(() => import("views/app-views/amalfi-demo")),
    meta: { blankLayout: true },
  },
  {
    key: "money2020",
    path: `${APP_PREFIX_PATH}/redeem-campaign/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "pick-winner",
    path: `${APP_PREFIX_PATH}/pick-winner/:raffle_id`,
    component: React.lazy(() => import("views/app-views/pick-winner")),
    meta: { blankLayout: true },
  },
  {
    // Christmas skin of pick-winner — same component, christmas variant styling
    key: "pick-winner-christmas",
    path: `${APP_PREFIX_PATH}/pick-winner-christmas/:raffle_id`,
    component: React.lazy(() => import("views/app-views/pick-winner")),
    meta: { blankLayout: true },
  },
  {
    key: "redeem-ana",
    path: `${APP_PREFIX_PATH}/redeem-ana/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "redeem-seba",
    path: `${APP_PREFIX_PATH}/redeem-seba/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "redeem-timon",
    path: `${APP_PREFIX_PATH}/redeem-timon/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "redeem-arne",
    path: `${APP_PREFIX_PATH}/redeem-arne/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "redeem-thomas",
    path: `${APP_PREFIX_PATH}/redeem-thomas/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "center-parcs",
    path: `${APP_PREFIX_PATH}/center-parcs`,
    component: React.lazy(() => import("views/app-views/center-parcs")),
    meta: { blankLayout: true },
  },
  {
    key: "proximus",
    path: `${APP_PREFIX_PATH}/proximus`,
    component: React.lazy(() => import("views/app-views/proximus")),
    meta: { blankLayout: true },
  },
  {
    key: "cancel-user-invitation",
    path: `${AUTH_PREFIX_PATH}/cancel-invitation`,
    component: React.lazy(() => import("views/app-views/cancel-invitation")),
  },
  {
    key: "brand-store-preview",
    path: `${APP_PREFIX_PATH}/preview/brand-store`,
    component: React.lazy(() => import("views/brand-store/preview")),
    meta: { blankLayout: true },
  },
  {
    key: "brand-store-event-preview",
    path: `${APP_PREFIX_PATH}/preview/brand-store-event`,
    component: React.lazy(() => import("views/app-views/fair-and-events/preview")),
    meta: { blankLayout: true },
  },
  {
    key: "wishlist-preview",
    path: `${APP_PREFIX_PATH}/preview/wishlist`,
    component: React.lazy(() => import("views/wishlist-preview")),
    meta: { blankLayout: true },
  },
];

export const inactiveCompanyRoutes = [
  {
    key: "inactive-company-warning",
    path: `${APP_PREFIX_PATH}/company-inactive`,
    component: React.lazy(() => import("views/app-views/company-inactive")),
  },
];

export const protectedRoutes = [
  {
    key: "surcharges-info",
    path: `${APP_PREFIX_PATH}/surcharges-info`,
    component: React.lazy(() => import("views/app-views/surcharges-info")),
    meta: {},
  },
  {
    key: "dashboard.analytic",
    path: `${APP_PREFIX_PATH}/dashboard`,
    component: React.lazy(() => import("views/app-views/dashboards/analytic")),
    meta: { isWardrobe: true },
  },
  {
    key: "redeem-campaign",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign`,
    component: React.lazy(() => import("views/app-views/redeem-campaign")),
    meta: { blankLayout: true },
  },
  {
    key: "internal-request-campaign",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/internal-request`,
    component: React.lazy(() => import("views/app-views/internal-request-campaign")),
    meta: { blankLayout: true },
  },
  {
    // New sharable_open_link format — must exist in BOTH route arrays so the
    // page also opens for logged-in users (publicRoutes only mount when
    // there's no auth cookie)
    key: "request-forms-public",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/request-forms`,
    component: React.lazy(() => import("views/app-views/internal-request-campaign")),
    meta: { blankLayout: true },
  },
  {
    key: "live-quiz-screen",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/live-quiz`,
    component: React.lazy(() => import("views/app-views/live-quiz/screen")),
    meta: { blankLayout: true },
  },
  {
    key: "live-quiz-join",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/live-quiz/join`,
    component: React.lazy(() => import("views/app-views/live-quiz/join")),
    meta: { blankLayout: true },
  },
  {
    key: "live-quiz-screen-coded",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/live-quiz/:code`,
    component: React.lazy(() => import("views/app-views/live-quiz/screen")),
    meta: { blankLayout: true },
  },
  {
    key: "live-quiz-join-coded",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/live-quiz/:code/join`,
    component: React.lazy(() => import("views/app-views/live-quiz/join")),
    meta: { blankLayout: true },
  },
  {
    key: "fair-and-events-onboarding",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/spin-the-wheel-onboarding/:companySlug`,
    component: React.lazy(() => import("views/app-views/fair-and-events/onboarding")),
    meta: { blankLayout: true },
  },
  {
    key: "fair-and-events-wheel-amalfi",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/spin-the-wheel/amalfi/:activationId`,
    component: React.lazy(() => import("views/app-views/fair-and-events/amalfi")),
    meta: { blankLayout: true },
  },
  {
    key: "fair-and-events-wheel",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/spin-the-wheel/:activationId`,
    component: React.lazy(() => import("views/app-views/fair-and-events")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas-spin-the-wheel",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/christmas-spin-the-wheel/:activationId`,
    component: React.lazy(() => import("views/app-views/fair-and-events/christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas-spin-the-wheel-base",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/christmas-spin-the-wheel`,
    component: React.lazy(() => import("views/app-views/fair-and-events/christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas-advent-calendar",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/christmas-advent-calendar/:activationId`,
    component: React.lazy(() => import("views/app-views/christmas-advent-calendar")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas-advent-calendar-base",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/christmas-advent-calendar`,
    component: React.lazy(() => import("views/app-views/christmas-advent-calendar")),
    meta: { blankLayout: true },
  },
  {
    key: "event-campaign",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/event-campaign`,
    component: React.lazy(() => import("views/app-views/event-campaign")),
    meta: { blankLayout: true },
  },
  {
    key: "websummit",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/websummit`,
    component: React.lazy(() => import("views/app-views/websummit")),
  },
  {
    key: "websummit-mystery",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/websummit/mystery`,
    component: React.lazy(() => import("views/app-views/websummit")),
  },
  {
    key: "amalfi",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/amalfi`,
    component: React.lazy(() => import("views/app-views/amalfi")),
    meta: { blankLayout: true },
  },
  {
    key: "donna",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/donna`,
    component: React.lazy(() => import("views/app-views/donna")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/christmas`,
    component: React.lazy(() => import("views/app-views/christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "synergie",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/synergie`,
    component: React.lazy(() => import("views/app-views/synergie")),
    meta: { blankLayout: true },
  },
  {
    key: "synergie-christmas",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/synergie-christmas`,
    component: React.lazy(() => import("views/app-views/synergie-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "expertum-christmas",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/expertum-christmas`,
    component: React.lazy(() => import("views/app-views/expertum-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "imens",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/imens`,
    component: React.lazy(() => import("views/app-views/imens")),
    meta: { blankLayout: true },
  },
  {
    key: "appodeal",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/appodeal`,
    component: React.lazy(() => import("views/app-views/appodeal")),
    meta: { blankLayout: true },
  },
  {
    key: "vanloot",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/vanloot`,
    component: React.lazy(() => import("views/app-views/vanloot")),
    meta: { blankLayout: true },
  },
  {
    key: "bankb",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/bankb`,
    component: React.lazy(() => import("views/app-views/bankb")),
    meta: { blankLayout: true },
  },
  {
    key: "bankb-christmas",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/bankb-christmas`,
    component: React.lazy(() => import("views/app-views/bankb-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "bankb-christmas-s",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/bankb-christmas-s`,
    component: React.lazy(() => import("views/app-views/bankb-christmas-s")),
    meta: { blankLayout: true },
  },
  {
    key: "imens-christmas",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/imens-christmas`,
    component: React.lazy(() => import("views/app-views/imens-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "i-mens-christmas",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/i-mens-christmas`,
    component: React.lazy(() => import("views/app-views/i-mens-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "testronic",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/testronic`,
    component: React.lazy(() => import("views/app-views/testronic")),
    meta: { blankLayout: true },
  },
  {
    key: "testronic-christmas",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/testronic-christmas`,
    component: React.lazy(() => import("views/app-views/testronic-christmas")),
    meta: { blankLayout: true },
  },
  {
    key: "christmas-gift",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/christmas-gift`,
    component: React.lazy(() => import("views/app-views/christmas-gift")),
    meta: { blankLayout: true },
  },
  {
    key: "nexo",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/nexo`,
    component: React.lazy(() => import("views/app-views/nexo")),
    meta: { blankLayout: true },
  },
  {
    key: "nexo-crypto",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/nexo-crypto`,
    component: React.lazy(() => import("views/app-views/nexo-crypto")),
    meta: { blankLayout: true },
  },
  {
    key: "amalfi-demo",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/demo/amalfi`,
    component: React.lazy(() => import("views/app-views/amalfi-demo")),
    meta: { blankLayout: true },
  },
  {
    key: "money2020",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "pick-winner",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/pick-winner/:raffle_id`,
    component: React.lazy(() => import("views/app-views/pick-winner")),
    meta: { blankLayout: true },
  },
  {
    // Christmas skin of pick-winner — same component, christmas variant styling
    key: "pick-winner-christmas",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/pick-winner-christmas/:raffle_id`,
    component: React.lazy(() => import("views/app-views/pick-winner")),
    meta: { blankLayout: true },
  },
  {
    key: "redeem-ana",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-ana/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "redeem-seba",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-seba/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "redeem-timon",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-timon/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "redeem-arne",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-arne/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "redeem-thomas",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-thomas/vivatech`,
    component: React.lazy(() => import("views/app-views/money2020")),
    meta: { blankLayout: true },
  },
  {
    key: "center-parcs",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/center-parcs`,
    component: React.lazy(() => import("views/app-views/center-parcs")),
    meta: { blankLayout: true },
  },
  {
    key: "proximus",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/proximus`,
    component: React.lazy(() => import("views/app-views/proximus")),
    meta: { blankLayout: true },
  },
  {
    key: "follow-up-questionnaire",
    path: `${APP_PREFIX_PATH}/follow-up`,
    component: React.lazy(
      () => import("views/app-views/follow-up-questionnaire-app"),
    ),
  },
  {
    key: "followUp.campaigns",
    path: `${APP_PREFIX_PATH}/follow-ups-templates`,
    component: React.lazy(() => import("views/app-views/follow-ups/templates")),
    meta: { isWardrobe: true },
  },
  {
    key: "followUp.schedules",
    path: `${APP_PREFIX_PATH}/follow-ups-schedules`,
    component: React.lazy(() => import("views/app-views/follow-ups/schedules")),
    meta: { isWardrobe: true },
  },
  {
    key: "dashboard.integrations",
    path: `${APP_PREFIX_PATH}/integrations/:id`,
    component: React.lazy(
      () => import("views/app-views/select-integration-products"),
    ),
    meta: { requiredRoles: ["OWNER", "ADMIN"] },
  },
  {
    key: "users.invitations.accept",
    path: `${AUTH_PREFIX_PATH}/invitation`,
    component: React.lazy(() => import("views/app-views/user-invitation")),
  },
  {
    key: "dashboard.integrations.select-products",
    path: `${APP_PREFIX_PATH}/integrations`,
    component: React.lazy(() => import("views/app-views/integrations")),
    meta: { requiredRoles: ["OWNER", "ADMIN"] },
  },
  {
    key: "dashboard.notifications",
    path: `${APP_PREFIX_PATH}/notifications`,
    component: React.lazy(() => import("views/app-views/notifications-page")),
  },
  {
    key: "users.invitations",
    path: `${APP_PREFIX_PATH}/user-invitations`,
    component: React.lazy(() => import("views/app-views/user-invitations")),
    meta: { requiredRoles: ["OWNER", "ADMIN"] },
  },
  {
    key: "dashboard.companies",
    path: `${APP_PREFIX_PATH}/company`,
    component: React.lazy(() => import("views/app-views/edit-company")),
    meta: { requiredRoles: ["OWNER", "ADMIN"] },
  },
  {
    key: "branding",
    path: `${APP_PREFIX_PATH}/branding`,
    component: React.lazy(() => import("views/app-views/branding")),
    meta: { blankLayout: true },
  },
  {
    key: "dashboard.products",
    path: `${APP_PREFIX_PATH}/products`,
    component: React.lazy(() => import("views/app-views/product-list")),
    meta: { isWardrobe: true },
  },
  {
    key: "dashboard.packages",
    path: `${APP_PREFIX_PATH}/packages`,
    component: React.lazy(() => import("views/app-views/packages-list")),
    meta: { isWardrobe: true },
  },
  {
    key: "dashboard.inventory-reorder",
    path: `${APP_PREFIX_PATH}/inventory-reorder`,
    component: React.lazy(() => import("views/app-views/inventory-reorder")),
    meta: { isWardrobe: true },
  },
  {
    key: "dashboard.intake-requests",
    path: `${APP_PREFIX_PATH}/intake-requests`,
    component: React.lazy(() => import("views/app-views/intake-requests")),
    meta: { isWardrobe: true, requiredRoles: ["OWNER", "ADMIN"] },
  },
  // Tickets/Complaints route disabled — BE ticket routes not available yet
  // (Bogdan, 08.10.2026). Re-enable with the nav item + ShipmentDetailsSidebar
  // TicketsSection when the API lands.
  // {
  //   key: "dashboard.complaints",
  //   path: `${APP_PREFIX_PATH}/complaints`,
  //   component: React.lazy(() => import("views/app-views/complaints")),
  //   meta: { isWardrobe: true, requiredRoles: ["OWNER", "ADMIN"] },
  // },
  {
    key: "dashboard.stock-transfers",
    path: `${APP_PREFIX_PATH}/stock-transfers`,
    component: React.lazy(() => import("views/app-views/stock-transfers")),
    meta: { isWardrobe: true, requiredRoles: ["OWNER", "ADMIN"] },
  },
  {
    key: "dashboard.create-inventory-reorder",
    path: `${APP_PREFIX_PATH}/inventory-reorder/create`,
    component: React.lazy(() => import("views/app-views/create-inventory-reorder")),
    meta: { isWardrobe: true },
  },
  {
    key: "dashboard.edit-packages",
    path: `${APP_PREFIX_PATH}/packages/:id`,
    component: React.lazy(() => import("views/app-views/edit-package")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.edit-product",
    path: `${APP_PREFIX_PATH}/products/:id`,
    component: React.lazy(() => import("views/app-views/edit-product")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.add-products",
    path: `${APP_PREFIX_PATH}/products/create`,
    component: React.lazy(() => import("views/app-views/add-product")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.shipments",
    path: `${APP_PREFIX_PATH}/shipments`,
    component: React.lazy(() => import("views/app-views/shipments")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.invoices",
    path: `${APP_PREFIX_PATH}/invoices`,
    component: React.lazy(() => import("views/app-views/invoices")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.company.cost-centers",
    path: `${APP_PREFIX_PATH}/cost-centers`,
    component: React.lazy(() => import("views/app-views/cost-centers")),
    // Gated by the company-level has_cost_center flag (see routes/index.js).
    meta: { requiresCostCenter: true },
  },
  {
    key: "apps.wardrobe.request-forms-regions",
    path: `${APP_PREFIX_PATH}/request-forms/regions`,
    component: React.lazy(() => import("views/app-views/request-forms/regions")),
    meta: { isWardrobe: true, requiresRequestFormsAccess: true },
  },
  {
    key: "apps.wardrobe.request-forms-forms",
    path: `${APP_PREFIX_PATH}/request-forms/forms`,
    component: React.lazy(() => import("views/app-views/request-forms/forms")),
    meta: { isWardrobe: true, requiresRequestFormsAccess: true },
  },
  {
    key: "apps.wardrobe.request-forms-requests",
    path: `${APP_PREFIX_PATH}/request-forms/requests`,
    component: React.lazy(() => import("views/app-views/request-forms/requests")),
    meta: { isWardrobe: true, requiresRequestFormsAccess: true },
  },
  {
    key: "apps.ecommerce.shipments-edit",
    path: `${APP_PREFIX_PATH}/shipments/:id/edit`,
    component: React.lazy(() => import("views/app-views/create-custom-shipment")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.shipments-select-type",
    path: `${APP_PREFIX_PATH}/shipments/create`,
    component: React.lazy(() => import("views/app-views/select-shipment-type")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.shipments-create-custom",
    path: `${APP_PREFIX_PATH}/shipments/create-custom`,
    component: React.lazy(
      () => import("views/app-views/create-custom-shipment"),
    ),
    // requiresCustomShipmentAccess: user-only gate on CREATION only. The edit
    // route above keeps `isWardrobe` only, so existing shipments stay editable.
    meta: { isWardrobe: true, requiresCustomShipmentAccess: true },
  },
  {
    key: "apps.ecommerce.shipments-create",
    path: `${APP_PREFIX_PATH}/shipments/send-packages`,
    component: React.lazy(
      () => import("views/app-views/create-packages-shipment"),
    ),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.shipments-edit-packages",
    path: `${APP_PREFIX_PATH}/shipments/send-packages/:id`,
    component: React.lazy(
      () => import("views/app-views/create-packages-shipment"),
    ),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.shipments-create-bulk",
    path: `${APP_PREFIX_PATH}/shipments/send-bulk`,
    component: React.lazy(() => import("views/app-views/create-bulk-shipment")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.shipments-edit-bulk",
    path: `${APP_PREFIX_PATH}/shipments/send-bulk/:id`,
    component: React.lazy(() => import("views/app-views/create-bulk-shipment")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.shipments-create-file",
    path: `${APP_PREFIX_PATH}/shipments/send-file`,
    component: React.lazy(() => import("views/app-views/create-file-shipment")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.shipments-edit-file",
    path: `${APP_PREFIX_PATH}/shipments/send-file/:id`,
    component: React.lazy(() => import("views/app-views/create-file-shipment")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.ecommerce.shipment-view",
    path: `${APP_PREFIX_PATH}/shipments/:id`,
    component: React.lazy(() => import("views/app-views/view-shipment")),
    meta: { isWardrobe: true },
  },
  {
    key: "pages.settings",
    path: `${APP_PREFIX_PATH}/settings/*`,
    component: React.lazy(() => import("views/app-views/settings")),
  },
  {
    key: "pages.users",
    path: `${APP_PREFIX_PATH}/users`,
    component: React.lazy(() => import("views/app-views/user-list")),
    meta: { requiredRoles: ["OWNER", "ADMIN"], allowClosetAdmin: true },
  },
  {
    key: "pages.users-invitations",
    path: `${APP_PREFIX_PATH}/users-invite`,
    component: React.lazy(() => import("views/app-views/users-invite")),
    meta: { requiredRoles: ["OWNER", "ADMIN"] },
  },
  {
    key: "pages.campaigns",
    path: `${APP_PREFIX_PATH}/campaigns`,
    component: React.lazy(() => import("views/app-views/campaigns")),
    meta: { isWardrobe: true },
  },
  {
    // Static path, so React Router v6 ranks it above /campaigns/:id automatically.
    key: "apps.campaigns.burner-links",
    path: `${APP_PREFIX_PATH}/campaigns/burner-links`,
    component: React.lazy(() => import("views/app-views/campaign-burner-links")),
    meta: { isWardrobe: true, requiresNexoCompany: true },
  },
  {
    key: "apps.campaigns.edit-campaign",
    path: `${APP_PREFIX_PATH}/campaigns/:id`,
    component: React.lazy(() => import("views/app-views/edit-campaign")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.merch-metrics-analytics",
    path: `${APP_PREFIX_PATH}/analytics`,
    component: React.lazy(
      () => import("views/app-views/merch-metrics-analytics"),
    ),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.campaigns.campaign-analytics",
    path: `${APP_PREFIX_PATH}/campaigns/:id/analytics`,
    component: React.lazy(() => import("views/app-views/campaign-analytics")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.campaigns.edit-redeem-campaign",
    path: `${APP_PREFIX_PATH}/redeem-campaigns/:id`,
    component: React.lazy(() => import("views/app-views/edit-redeem-campaign")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.campaigns.edit-event-campaign",
    path: `${APP_PREFIX_PATH}/event-campaigns/:id`,
    component: React.lazy(() => import("views/app-views/edit-event-campaign")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.campaigns.edit-internal-request-campaign",
    path: `${APP_PREFIX_PATH}/request-forms/forms/:id`,
    component: React.lazy(() => import("views/app-views/edit-internal-request-campaign")),
    meta: { isWardrobe: true, requiresRequestFormsAccess: true },
  },
  {
    key: "apps.campaigns.select-type",
    path: `${APP_PREFIX_PATH}/campaigns/create`,
    component: React.lazy(() => import("views/app-views/select-campaign-type")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.campaigns.create-simple",
    path: `${APP_PREFIX_PATH}/campaigns/create-simple`,
    component: React.lazy(() => import("views/app-views/create-campaign")),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.campaigns.create-campaign",
    path: `${APP_PREFIX_PATH}/campaigns/create-redeem`,
    component: React.lazy(
      () => import("views/app-views/create-shipping-campaign"),
    ),
    meta: { isWardrobe: true },
  },
  {
    key: "apps.campaigns.create-event-campaign",
    path: `${APP_PREFIX_PATH}/campaigns/create-event`,
    component: React.lazy(
      () => import("views/app-views/create-event-campaign"),
    ),
    meta: { isWardrobe: true },
  },
  {
    key: "pages.closets",
    path: `${APP_PREFIX_PATH}/teams`,
    component: React.lazy(() => import("views/app-views/closets")),
    meta: { requiredRoles: ["OWNER", "ADMIN"] },
  },
  {
    key: "pages.closets.create-closet",
    path: `${APP_PREFIX_PATH}/teams/create`,
    component: React.lazy(() => import("views/app-views/create-closet")),
    meta: { requiredRoles: ["OWNER", "ADMIN"] },
  },
  {
    key: "pages.closets.edit-closet",
    path: `${APP_PREFIX_PATH}/teams/:id`,
    component: React.lazy(() => import("views/app-views/edit-closet")),
    meta: { requiredRoles: ["OWNER", "ADMIN"] },
  },
  {
    key: "pages.recipients",
    path: `${APP_PREFIX_PATH}/recipients`,
    component: React.lazy(() => import("views/app-views/recipients")),
    meta: { isWardrobe: true },
  },
  {
    key: "pages.closets.create-recipient",
    path: `${APP_PREFIX_PATH}/recipients/create`,
    component: React.lazy(() => import("views/app-views/create-recipient")),
    meta: { isWardrobe: true },
  },
  {
    key: "pages.closets.edit-recipient",
    path: `${APP_PREFIX_PATH}/recipients/:id`,
    component: React.lazy(() => import("views/app-views/edit-recipient")),
    meta: { isWardrobe: true },
  },
  {
    key: "pages.closets.recipient-shipments",
    path: `${APP_PREFIX_PATH}/recipients/:id/shipments`,
    component: React.lazy(() => import("views/app-views/recipient-shipments")),
    meta: { isWardrobe: true },
  },
  {
    key: "pages.closets.create-recipient-address",
    path: `${APP_PREFIX_PATH}/recipients/:id/create`,
    component: React.lazy(
      () => import("views/app-views/create-recipient-address"),
    ),
    meta: { isWardrobe: true },
  },
  {
    key: "pages.closets.edit-recipient-address",
    path: `${APP_PREFIX_PATH}/recipients/:id/address/:address_id`,
    component: React.lazy(
      () => import("views/app-views/edit-recipient-address"),
    ),
    meta: { isWardrobe: true },
  },
  {
    key: "pages.errors.404",
    path: `${APP_PREFIX_PATH}/error/404`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
  },
  {
    key: "pages.campaigns.emails",
    path: `${APP_PREFIX_PATH}/campaigns/:id/emails`,
    component: React.lazy(() => import("views/app-views/campaign-emails")),
    meta: { isWardrobe: true },
  },
];

// Onboarding Routes
export const onboardingRoutes = [
  {
    key: "onboarding.brand-details",
    path: `${APP_PREFIX_PATH}/onboarding/brand-details`,
    component: React.lazy(() => import("views/onboarding/brand-details")),
    meta: { blankLayout: true },
  },
];

// Agency Routes
export const agencyRoutes = [
  {
    key: "agency.dashboard",
    path: `${APP_PREFIX_PATH}/agency/dashboard`,
    component: React.lazy(() => import("views/agency/dashboard")),
  },
  {
    key: "agency.companies",
    path: `${APP_PREFIX_PATH}/agency/companies`,
    component: React.lazy(() => import("views/agency/companies")),
  },
  {
    key: "agency.orders",
    path: `${APP_PREFIX_PATH}/agency/orders`,
    component: React.lazy(() => import("views/agency/orders")),
  },
  {
    key: "agency.users",
    path: `${APP_PREFIX_PATH}/agency/users`,
    component: React.lazy(() => import("views/agency/users")),
  },
  {
    key: "agency.carts",
    path: `${APP_PREFIX_PATH}/agency/carts`,
    component: React.lazy(() => import("views/agency/carts")),
  },
  {
    key: "agency.productRequests",
    path: `${APP_PREFIX_PATH}/agency/product-requests`,
    component: React.lazy(() => import("views/agency/product-requests")),
  },
];

// Brand Store Routes
export const brandStoreRoutes = [
  {
    key: "brand-store.homepage",
    path: `${APP_PREFIX_PATH}/brand-store`,
    component: React.lazy(() => import("views/brand-store/homepage")),
    meta: { isBrandStore: true },
  },
  {
    key: "brand-store.collections",
    path: `${APP_PREFIX_PATH}/brand-store/collections`,
    component: React.lazy(() => import("views/brand-store/collections")),
    meta: { isBrandStore: true },
  },
  {
    key: "brand-store.edit-collection",
    path: `${APP_PREFIX_PATH}/brand-store/collections/:id`,
    component: React.lazy(() => import("views/brand-store/edit-collection")),
    meta: { isBrandStore: true },
  },
  {
    key: "brand-store.create-collection",
    path: `${APP_PREFIX_PATH}/brand-store/collections/create`,
    component: React.lazy(() => import("views/brand-store/create-collection")),
    meta: { isBrandStore: true },
  },
  {
    key: "brand-store.products",
    path: `${APP_PREFIX_PATH}/brand-store/products`,
    component: React.lazy(() => import("views/brand-store/products")),
    meta: { isBrandStore: true },
  },
  {
    key: "brand-store.edit-product",
    path: `${APP_PREFIX_PATH}/brand-store/products/:id`,
    component: React.lazy(() => import("views/brand-store/productItem")),
    meta: { isBrandStore: true },
  },
  {
    key: "brand-store.cart",
    path: `${APP_PREFIX_PATH}/brand-store/cart`,
    component: React.lazy(() => import("views/brand-store/cart")),
    meta: { isBrandStore: true },
  },
  {
    key: "brand-store.checkout",
    path: `${APP_PREFIX_PATH}/brand-store/checkout`,
    component: React.lazy(() => import("views/brand-store/cart/components/Checkout")),
    meta: { isBrandStore: true },
  },
  {
    key: "brand-store.order-details",
    path: `${APP_PREFIX_PATH}/brand-store/orders/:id`,
    component: React.lazy(() => import("views/brand-store/orders/OrderDetails")),
    meta: { isBrandStore: true },
  },
  {
    key: "brand-store.orders",
    path: `${APP_PREFIX_PATH}/brand-store/orders`,
    component: React.lazy(() => import("views/brand-store/orders")),
    meta: { isBrandStore: true },
  }
];

// Catalog Routes
export const catalogRoutes = [
  {
    key: "catalog.homepage",
    path: `${APP_PREFIX_PATH}/catalog`,
    component: React.lazy(() => import("views/catalog/homepage")),
    meta: { isCatalog: true },
  },
  {
    key: "catalog.products",
    path: `${APP_PREFIX_PATH}/catalog/products`,
    component: React.lazy(() => import("views/catalog/products")),
    meta: { isCatalog: true },
  },
  {
    key: "catalog.product-item",
    path: `${APP_PREFIX_PATH}/catalog/products/:id`,
    component: React.lazy(() => import("views/catalog/productItem")),
    meta: { isCatalog: true },
  },
  // Dedicated "View all bundle products" list page (re-enabled — see
  // catalog-bundles-fe-spec.md). "View all" links from the bundles carousel and
  // top nav land here.
  {
    key: "catalog.bundles",
    path: `${APP_PREFIX_PATH}/catalog/bundles`,
    component: React.lazy(() => import("views/catalog/bundles")),
    meta: { isCatalog: true },
  },
  {
    key: "catalog.bundle-item",
    path: `${APP_PREFIX_PATH}/catalog/bundles/:id`,
    component: React.lazy(() => import("views/catalog/bundleItem")),
    meta: { isCatalog: true },
  },
  {
    key: "catalog.wishlist-edit",
    path: `${APP_PREFIX_PATH}/catalog/catalog-wishlists/:id/edit`,
    component: React.lazy(() => import("views/catalog/wishlists/edit")),
    meta: { isCatalog: true },
  },
  {
    key: "catalog.wishlist-detail",
    path: `${APP_PREFIX_PATH}/catalog/catalog-wishlists/:id`,
    component: React.lazy(() => import("views/catalog/wishlists/detail")),
    meta: { isCatalog: true },
  },
  {
    key: "catalog.wishlists",
    path: `${APP_PREFIX_PATH}/catalog/catalog-wishlists`,
    component: React.lazy(() => import("views/catalog/wishlists")),
    meta: { isCatalog: true },
  },
  // Share a single lazy component across both /catalog/ai-chat and
  // /catalog/ai-chat/:id so the page does not remount when a brand-new
  // conversation receives its URL — remounting cancels the in-flight stream
  // and the user message is lost.
  ...(() => {
    const AiChatComponent = React.lazy(() => import("views/app-views/ai-chat"));
    return [
      {
        key: "catalog.ai-chat",
        path: `${APP_PREFIX_PATH}/catalog/ai-chat`,
        component: AiChatComponent,
        meta: { isCatalog: true },
      },
      {
        key: "catalog.ai-chat.conversation",
        path: `${APP_PREFIX_PATH}/catalog/ai-chat/:conversationId`,
        component: AiChatComponent,
        meta: { isCatalog: true },
      },
    ];
  })(),
];

export const fullPageProtectedRoutePaths = protectedRoutes
  .filter((route) => route.isRenderedFullPage)
  ?.map((route) => route.path.replace(APP_PREFIX_PATH, ""));
